module.exports = __webpack_public_path__ + "static/media/robosg.1b7a6a71.jpeg";